import { SortType } from '@appTypes/SortType';
import { Dispatch, SetStateAction, useState } from 'react';
import { SortDirection } from '../enums/SortDirection';
import { usePrevious } from './UsePrevious';

export const useSort = (defaultSort: SortType): UseSortReturnType => {
  const [sort, setSort] = useState({
    sortDirection: defaultSort.sortDirection,
    accessor: defaultSort.accessor,
    subSort: defaultSort.subSort,
    subSortDirection: defaultSort.subSortDirection,
  });

  const previousSort = usePrevious<SortType>(sort);

  const onSortChange = (sortType: SortType) => {
    if (previousSort.accessor !== sortType.accessor) {
      const updatedSortDirection = getSortDirection(previousSort.sortDirection);
      assignSort(
        updatedSortDirection,
        sortType.accessor,
        sortType.subSort,
        sortType.subSortDirection,
      );
    } else {
      assignSort(
        sortType.sortDirection,
        sortType.accessor,
        sortType.subSort,
        sortType.subSortDirection,
      );
    }
  };

  const getSortDirection = (sortDirection: SortDirection): SortDirection => {
    switch (sortDirection) {
      case SortDirection.None:
        return SortDirection.Ascending;

      case SortDirection.Descending:
        return SortDirection.Ascending;

      case SortDirection.Ascending:
        return SortDirection.Descending;
    }
  };

  const assignSort = (
    sortDirection: SortDirection,
    accessor: string,
    subSort: string,
    subSortDirection: SortDirection,
  ): void => {
    switch (sortDirection) {
      case SortDirection.None:
        setSort({
          sortDirection: SortDirection.Ascending,
          accessor: accessor,
          subSort: subSort,
          subSortDirection: subSortDirection,
        });
        break;

      case SortDirection.Ascending:
        setSort({
          sortDirection: SortDirection.Descending,
          accessor: accessor,
          subSort: subSort,
          subSortDirection: subSortDirection,
        });
        break;

      case SortDirection.Descending:
        setSort({
          sortDirection: SortDirection.Ascending,
          accessor: accessor,
          subSort: subSort,
          subSortDirection: subSortDirection,
        });
        break;
    }
  };

  return {
    sort,
    setSort,
    onSortChange,
  };
};

type UseSortReturnType = {
  sort: SortType;
  setSort: Dispatch<SetStateAction<SortType>>;
  onSortChange: (sort: SortType) => void;
};
